import type { LibraryResponses } from "@tfg/types/endpoints/library"

import type { CustomFieldDefinitions } from "./custom-field-graph.types"

export function getSortedComponents(
  product: LibraryResponses.ProductDetails
): LibraryResponses.EnrichedComponent[] {
  return [...product.components].sort(
    (left, right) => Number(right.mainFabric) - Number(left.mainFabric)
  )
}

export function getVerticalDividerCoveredCardsCount(
  product: LibraryResponses.ProductDetails,
  sortedComponents: readonly LibraryResponses.EnrichedComponent[]
): number {
  return sortedComponents.reduce((sum, component, index) => {
    if (index === product.components.length - 1) {
      return sum + 1
    }
    return sum + (component.materials.length || 1)
  }, 0)
}

export function getProductActivityIds(
  product: LibraryResponses.ProductDetails
): string[] {
  return product.item.operations.map((operation) => operation.activityId)
}

export function getProductLevelCustomFieldDefinitions(
  product: LibraryResponses.ProductDetails,
  productActivityIds: readonly string[]
): CustomFieldDefinitions {
  return product.customFieldDefinitions.filter((definition) =>
    productActivityIds.includes(definition.forActivityId)
  )
}

export function getCustomFieldDefinitionsForItem(
  product: LibraryResponses.ProductDetails,
  item: LibraryResponses.EnrichedItem,
  productActivityIds: readonly string[]
): CustomFieldDefinitions {
  const itemActivityIds = item.operations.map((operation) => operation.activityId)

  return product.customFieldDefinitions.filter(
    (definition) =>
      itemActivityIds.includes(definition.forActivityId) &&
      (!definition.onActivityId ||
        productActivityIds.includes(definition.onActivityId))
  )
}
